import React from "react";

const PartnerCouponReportTable = ({ rows = [], summary = {}, showPartner = false }) => (
  <div className="script-box text-start p-3 mt-4">
    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
      <h2 className="package-h4 mt-2 mb-0">Coupon Usage Report</h2>
      <div className="d-flex gap-3 flex-wrap">
        <span className="column-text">Usage: {summary.usageCount || 0}</span>
        <span className="column-text">Sales: ${summary.discountedSales || "0.00"}</span>
        <span className="column-text">Discount: ${summary.discountGiven || "0.00"}</span>
        <span className="column-text">Commission: ${summary.commissionPayable || "0.00"}</span>
      </div>
    </div>
    <div className="table-responsive">
      <table className="table table-sm align-middle mb-0">
        <thead>
          <tr>
            {showPartner ? <th>Partner</th> : null}
            <th>Coupon</th>
            <th>Channel</th>
            <th className="text-end">Usage</th>
            <th className="text-end">Original Sales</th>
            <th className="text-end">Discounted Sales</th>
            <th className="text-end">Discount Given</th>
            <th className="text-end">Commission</th>
          </tr>
        </thead>
        <tbody>
          {rows.length ? (
            rows.map((row) => (
              <tr key={`${row.partnerId || ""}-${row.couponId || row.couponCode}-${row.channel}`}>
                {showPartner ? <td>{row.partnerName || "-"}</td> : null}
                <td>{row.couponCode || "-"}</td>
                <td className="text-capitalize">{row.channel || "-"}</td>
                <td className="text-end">{row.usageCount || 0}</td>
                <td className="text-end">${row.originalSales || "0.00"}</td>
                <td className="text-end">${row.discountedSales || "0.00"}</td>
                <td className="text-end">${row.discountGiven || "0.00"}</td>
                <td className="text-end">${row.commissionPayable || "0.00"}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={showPartner ? 8 : 7} className="text-center text-muted py-4">
                No coupon usage found for this date range.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default PartnerCouponReportTable;
